<template>
  <div class="page dashboard-page">
    <el-row :gutter="15" class="wrapper">
      <el-col :span="8">
        <el-row :gutter="15" class="special-card-wrapper">
          <el-col :lg="24">
            <div class="card section">
              <p class="page-title">小程序总数</p>
              <div class="content">
                <div class="item">
                  <p class="name">已授权小程序总数</p>
                  <h1><strong>{{wtpp_applications_count}}</strong></h1>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="8">
        <el-row :gutter="15" class="special-card-wrapper">
          <el-col :lg="24">
            <div class="card section">
              <p class="page-title">应用总数</p>
              <div class="content">
                <div class="item">
                  <p class="name">应用总数</p>
                  <h1><strong>{{applications_count}}</strong></h1>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="8">
        <el-row :gutter="15" class="special-card-wrapper">
          <el-col :lg="24">
            <div class="card section">
              <p class="page-title">用户总量</p>
              <div class="content">
                <div class="item">
                  <p class="name">用户总量</p>
                  <h1><strong>{{users_count}}</strong></h1>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <el-row class="wrapper">
      <div class="card section">
        <div class="content">
          <div class="visit-table">
            <p class="name">最近一周新增应用/用户情况</p>
            <bean-table :height="null" :value="table.data" :columns="columns" />
          </div>
        </div>
      </div>
    </el-row>
  </div>
</template>

<script>
  import { Vue, Component } from 'vue-property-decorator';

  @Component
  export default class SuperHome extends Vue {
    wtpp_applications_count = 0
    applications_count = 0
    users_count = 0
    table = {
      data: []
    }

    get columns() {
      return [
        {
          prop: 'ref_date',
          label: '日期'
        },
        {
          prop: 'new_applications_count',
          label: '应用数'
        },
        {
          prop: 'new_users_count',
          label: '用户数'
        }
      ];
    }

    async mounted() {
      const data = await this.$request.get('/dashboard');
      this.table.data = data.recent_one_week;
      this.wtpp_applications_count = data.wtpp_applications_count;
      this.applications_count = data.applications_count;
      this.users_count = data.users_count;
    }
  }
</script>
